// src/app/Components/Pages/Wrappers/ProfilWrapper.js
"use client";

import dynamic from "next/dynamic";

const Profil = dynamic(() => import("@/app/Components/Pages/Profil"), {
    ssr: false
});

export default function ProfilWrapper({ section }) {
  return <Profil section={section} />;
}
